import Image from "next/image";

export default function HighValueLoan({ data }) {
  const { sectionTitle, mainHeading, highValueImage } = data;

  return (
    <section className="bg-[#FFFFFF] py-sp-100 sm:py-sp-big">
      <div className="container px-3 xm:px-2">
        <p className="text-base2 text-baseBlack font-medium mb-3 text-center sm:text-lg">
          {sectionTitle}
        </p>
        <h2 className="text-heading md:text-xl text-baseBlack text-center sm:text-lg">
          {mainHeading}
        </h2>
        {/* Cards */}
        <div className="flex gap-3 mt-6 sm:flex-col">
          {highValueImage.map((item) => (
            <div key={item.id} className="bg-white rounded-lg sm:mb-2">
              <Image
                src={item.icon}
                alt={item.description}
                width={260}
                height={154}
                className="rounded-lg min-h-[154px] sm:w-full"
              />

              <p className="text-base2 text-baseBlack pt-2 text-center font-medium">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
